import { http } from '@/api/Connect';
import { BASE_WEB_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  IDownloadRequestStreamRecordItemResponse,
  IStreamRecordingsListResponse,
  IStreamRecordingsParams,
  TStreamRecord
} from '@/api/schema';

const API_STREAM_RECORDINGS = (): string =>
  `${BASE_WEB_OPERATOR()}/streams/archive`;

export async function getStreamRecordingsList(
  params?: IStreamRecordingsParams
): Promise<IStreamRecordingsListResponse> {
  return http
    .get(API_STREAM_RECORDINGS(), {
      params,
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<IStreamRecordingsListResponse>) => data);
}

export async function getStreamRecordItem(
  recordId: number | string
): Promise<TStreamRecord> {
  return http
    .get(`${API_STREAM_RECORDINGS()}/${recordId}`, {
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<TStreamRecord>) => data);
}

export async function downloadRequestStreamRecordItem(
  recordId: number | string
): Promise<IDownloadRequestStreamRecordItemResponse> {
  return http
    .post(`${API_STREAM_RECORDINGS()}/${recordId}/download/request`)
    .then(
      ({ data }: AxiosResponse): IDownloadRequestStreamRecordItemResponse =>
        data
    );
}
